export default "__VITE_ASSET__6c84ea23__"